module.exports = __webpack_public_path__ + "static/img/risk-icon5.1d7308ff.png";